import type { IPayable } from '../@types/Payable.js';

type LocalItemId = IPayable['localId'];
export type PaymentInfo<TExtraData extends object = object> = {
  message: string;
  localId: LocalItemId;
  type: 'PRE' | 'POST';
  extraData?: TExtraData;
};

/**
 * Message object to hold extra payment information.
 * Used eg. for payment confirmation.
 *
 * @returns The object to add and run tasks
 */
export function createPaymentInfo(): {
  add: (payment: PaymentInfo) => void;
  get: () => PaymentInfo[];
} {
  const paymentInfo: PaymentInfo[] = [];

  const add = ({ message, localId, type, extraData }: PaymentInfo): void => {
    const paymentInfoData = {
      message,
      localId,
      type,
      extraData,
    };

    paymentInfo.push(paymentInfoData);
  };

  const get = (): PaymentInfo[] => paymentInfo;

  return {
    add,
    get,
  } as const;
}

export type PaymentInfoType = ReturnType<typeof createPaymentInfo>;
